/** Created by azhou on 2019/2/26.*/
<template>
  <div class="d-center-around">
    <rectangle-comp bgColor="#85B0E1" >
      <h4>我的订单</h4>
      <p class="text-left" v-if="userInfo.type===3" @click="$emit('OrderHandle',userInfo.type,'0')">
        待&ensp;处&ensp;理<span :class="{'text-danger':IndexData.order_arr.wait_handle>0}"> {{IndexData.order_arr.wait_handle}}</span> 个
      </p>
      <p class="text-left" v-if="userInfo.type===3" @click="$emit('goOrderLists',userInfo.type,'1')">
        询&ensp;价&ensp;中<span :class="{'text-danger':IndexData.order_arr.status_4>0}"> {{IndexData.order_arr.status_4}}</span> 个
      </p>
      <p class="text-left" v-if="userInfo.type===3" @click="$emit('goOrderLists',userInfo.type,'today')">
        今日入住<span :class="{'text-danger':IndexData.order_arr.status_today>0}"> {{IndexData.order_arr.status_today}}</span> 个
      </p>
      <p class="text-left" v-if="userInfo.type===3" @click="$emit('goOrderLists',userInfo.type,'stay')">
        入&ensp;住&ensp;中<span :class="{'text-danger':IndexData.order_arr.status_stay>0}"> {{IndexData.order_arr.status_stay}}</span> 个
      </p>
      <p class="text-left" v-if="userInfo.type===3" @click="$emit('goOrderLists',userInfo.type,'all','2')">
        未&ensp;收&ensp;款<span :class="{'text-danger':IndexData.order_arr.wait_pay>0}"> {{IndexData.order_arr.wait_pay}}</span> 个
      </p>
    </rectangle-comp>
    <rectangle-comp bgColor="#80C9CE">
      <h4>房型管理</h4>
      <p @click="$router.push({name:'RoomMeetManage',query:{step:3}})">已添加房型：<span>{{IndexData.room_meeting_arr.room_count}}</span> 个</p>
      <p @click="$router.push({name:'RoomMeetManage',query:{step:4}})">已添加会议室：<span>{{IndexData.room_meeting_arr.meeting_count}}</span> 个</p>
    </rectangle-comp>
    <rectangle-comp bgColor="#F8C26A">
      <h4>资金管理</h4>
      <p @click="$emit('goFinancial','allowWithdraw')">门店余额：<span>{{IndexData.money_arr.money/100 | formatMoney}}</span> 元</p>
      <p @click="$emit('goFinancial','Freezing')">冻结金额：<span>{{IndexData.money_arr.freeze_money/100 | formatMoney}}</span> 元</p>
      <!-- <p @click="$emit('goFinancial','WithdrawDone')">累积提现：<span>{{IndexData.money_arr.withdrawMoney/100 | formatMoney}}</span> 元</p> -->
    </rectangle-comp>
    <rectangle-comp bgColor="#b8a6d8">
      <h4>人事管理</h4>
      <p @click="$router.push({name:'PositionManage'})">职位数量 <span>{{IndexData.position_arr.position_count}}</span> 个</p>
      <p @click="$router.push({name:'StaffManage'})">人员数量 <span>{{IndexData.position_arr.user_count}}</span> 个</p>
    </rectangle-comp>
  </div>
</template>

<script>
  import { mapGetters,mapState } from 'vuex'
  import RectangleComp from './RectangleComp'

  export default {
    name: 'HCenter',
    computed: {
      ...mapState(['IndexData']),
      ...mapGetters(['userInfo'])
    },
    components: { RectangleComp },
  }
</script>
<style scoped>
  .lse{
    color: #097e42;
  }
</style>
